import { useState } from 'react';

function ProfitabilityFilters({ onFilterChange }) {
  const [dateRange, setDateRange] = useState('30d');
  const [salesChannel, setSalesChannel] = useState('all');
  const [product, setProduct] = useState('all');
  const [sku, setSku] = useState('all');

  const handleFilterChange = (type, value) => {
    switch (type) {
      case 'dateRange':
        setDateRange(value);
        break;
      case 'salesChannel':
        setSalesChannel(value);
        break;
      case 'product':
        setProduct(value);
        break;
      case 'sku':
        setSku(value);
        break;
      default:
        break;
    }

    onFilterChange({
      dateRange,
      salesChannel,
      product,
      sku,
      [type]: value
    });
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm mb-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date Range
          </label>
          <select
            value={dateRange}
            onChange={(e) => handleFilterChange('dateRange', e.target.value)}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="7d">Last 7 days</option>
            <option value="30d">Last 30 days</option>
            <option value="90d">Last 90 days</option>
            <option value="ytd">Year to date</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Channel
          </label>
          <select
            value={salesChannel}
            onChange={(e) => handleFilterChange('salesChannel', e.target.value)}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="all">All Channels</option>
            <option value="amazon-uae">Amazon UAE</option>
            <option value="noon">Noon</option>
            <option value="jumia">Jumia</option>
            <option value="carrefour">Carrefour</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Product
          </label>
          <select
            value={product}
            onChange={(e) => handleFilterChange('product', e.target.value)}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="all">All Products</option>
            <option value="wireless-headphones">Wireless Headphones</option>
            <option value="smart-watch">Smart Watch</option>
            <option value="bluetooth-speaker">Bluetooth Speaker</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            SKU
          </label>
          <select
            value={sku}
            onChange={(e) => handleFilterChange('sku', e.target.value)}
            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="all">All SKUs</option>
            <option value="WH-001">WH-001</option>
            <option value="SW-001">SW-001</option>
            <option value="BS-001">BS-001</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default ProfitabilityFilters;